import months from '@anm/constants/months';
import getDateMonthYear from '@anm/helpers/date/getDateMonthYear';
import capitalize from '@anm/helpers/string/capitalize';
import useResize from '@anm/hooks/useResize';
import { useEffect, useState, FC } from 'react';

import { SectionTitle } from '../TemplatesSlider';

import Wrapper, { Content, Header, TransparentOverlay } from './Wrapper';
import { calcSize, DEFAULT_SIZE } from './helpers';
import { CalendarListProps } from './types';

export * from './types';

const CalendarList: FC<CalendarListProps> = ({
  data,
  children,
  renderCalendarItem
}) => {
  const [size, setSize] = useState(DEFAULT_SIZE);

  const [, monthIndex] = getDateMonthYear();
  const month = capitalize(months[monthIndex]);

  useEffect(() => {
    setSize(calcSize());
  }, []);

  useResize(() => {
    setSize(calcSize());
  });

  return (
    <Wrapper>
      <Header>
        <SectionTitle title={`Content calendar for ${month}`} level={2} />
        {children}
      </Header>
      <Content>
        <TransparentOverlay />
        {data.map(item => renderCalendarItem({ ...item, size }))}
      </Content>
    </Wrapper>
  );
};

export default CalendarList;
